module.exports = __webpack_public_path__ + "static/img/5bg_12.04be0be.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_12.png
// module id = 716
// module chunks = 1